import template from './partnerItem.html';
import controller from './partnerItem.controller';
import '../partnerDetailItem/partnerDetailItem';

export const partnerItemComponent = {
  name: 'partnerItemComponent',
  restrict: 'E',
  replace: true,
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    partner: '<',
    deleted: '<',
    onToggle: '&',
    onSelect: '&',
    selected: '=',
    savePartner: '&',
    readonly: '@'
  }
};
